import { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { IncidentIOTeamWithoutSchedulePicker } from '../../components/scaffolder/IncidentIOTeamWithoutSchedulePicker';

export const incidentIoTeamField: ExtensionDefinition = FormFieldBlueprint.make(
  {
    name: 'incident-io-team-without-schedule-picker',
    params: {
      field: async () =>
        createFormField({
          name: 'IncidentIOTeamWithoutSchedulePicker', // MUST match templates' ui:field
          component: IncidentIOTeamWithoutSchedulePicker,
        }),
    },
  },
);
